import adjustScrollbar from './adjust_scrollbar';
import clearTransform from './clear_transform';
import getOffsets from './get_offsets';
import getProximity from './get_proximity';
import getScrollbarWidth from './get_scrollbar_width';
import hitAnotherCategory from './hit_another_category';
import headerTransform from './header_transform';
import isFirefoxOnMac from './is_firefox_on_mac';

export {
    adjustScrollbar,
    clearTransform,
    getOffsets,
    getProximity,
    getScrollbarWidth,
    hitAnotherCategory,
    headerTransform,
    isFirefoxOnMac
};


// WEBPACK FOOTER //
// ./src/WrapperSection/helpers/index.js